/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderShopServiceTimeSlotDto } from './orderShopServiceTimeSlotDto';
import { CompartmentOrderDto } from './compartmentOrderDto';


export interface LightOrderDto { 
    id?: number | null;
    deliveryDate?: string;
    deliveryPlace?: string | null;
    deliveryTime?: string | null;
    notes?: string | null;
    status?: number;
    serviceTypeId?: number;
    shopId?: number;
    compartmentOrder?: CompartmentOrderDto;
    canCancel?: boolean;
    shopServiceTimeSlot?: OrderShopServiceTimeSlotDto;
}

